import * as React from 'react'
import { Col, Row } from 'antd'
import { formatEuro } from '../shared/CurrencyFormat'

import info_white from '../../content/info_white.svg'

import './HeaderCard.less'

interface HeaderCardProps extends React.HTMLAttributes<HTMLDivElement> {
  id: string
  importo: number
  durata: string
    tasso: string
  onDettaglioClick: (id: string) => void
}

export function HeaderCard(props: HeaderCardProps) {
  function handleKeyDown(e: React.KeyboardEvent<HTMLDivElement>) {
    if (props.onKeyDown) props.onKeyDown(e)
    if (!e.defaultPrevented && (e.key === 'Enter' || e.key === ' ')) {
      e.preventDefault()
      props.onDettaglioClick(props.id)
    }
  }

  return (
    <div
      tabIndex={props.tabIndex != null ? props.tabIndex : 0}
          role={props.role || 'button'} style={{ cursor: 'pointer' }}
      onClick={function () { props.onDettaglioClick(props.id) }}
      onKeyDown={handleKeyDown}
      {...props}
    >
      <div style={{ height: '280px' }}> {/* Il primo div è necessario per visualizzare l'indicatore del carosello */}
        <div className="header-card" style={{ margin: '24px' }}>
          <Row align="middle">
            <Col offset={1} lg={2} xs={4}>
                          <a onClick={() => props.onDettaglioClick(props.id)}><img src={info_white} alt="Dettaglio richiesta" tabIndex={0} role="presentation" /></a>
            </Col>
            <Col lg={21} xs={19}>
                <h1 className="Medium20White" style={{ margin: '0px' }}>La mia richiesta di mutuo</h1>
            </Col>
          </Row>
          <div className="header-card header-inner-card">
            <Row justify="center">
              <Col><span className="Medium32Credem400">{formatEuro(props.importo)}</span></Col>
            </Row>
            <Row justify="center">
              <Col><span className="Medium13Grey800">DURATA:&nbsp;</span></Col>
              <Col><span className="Medium13Credem400">{props.durata}</span></Col>
            </Row>
          </div>
        </div>
      </div>
    </div>
  )
}